import { PROMOTION_TYPE } from 'constants/promotion';

import { ReactComponent as BasicPromotionIcon } from 'assets/images/promotion/basic-promotion.svg';
import { ReactComponent as EarlyBookingPromotionIcon } from 'assets/images/promotion/early-booking-promotion.svg';
import { ReactComponent as LastMinPromotionIcon } from 'assets/images/promotion/last-min-promotion.svg';
import { ReactComponent as LongTermPromotionIcon } from 'assets/images/promotion/long-term-promotion.svg';
import { ReactComponent as MemberPromotionIcon } from 'assets/images/promotion/member-promotion.svg';
import { ReactComponent as SameProMotionIcon } from 'assets/images/promotion/same-promotion.svg';
import { ReactComponent as GuestPromotionIcon } from 'assets/images/guest-promotion.svg';
import { ReactComponent as AgencyPromotionIcon } from 'assets/images/agency-promotion.svg';
import { ReactComponent as EnterprisePromotionIcon } from 'assets/images/business-promotion.svg';
import { ReactComponent as RankPromotionIcon } from 'assets/images/rank-promotion.svg';
import { ReactComponent as MarketingPromotionIcon } from 'assets/images/marketing-promotion-1.svg';

const promotionRendering = (status) => {
  switch (status) {
    case PROMOTION_TYPE.BASIC:
      return {
        icon: BasicPromotionIcon,
        label: 'Ưu Đãi Cơ Bản',
      };

    case PROMOTION_TYPE.LONG_TERM:
      return {
        icon: LongTermPromotionIcon,
        label: 'Ưu Đãi Dài Hạn',
      };

    case PROMOTION_TYPE.LAST_DAY:
      return {
        icon: LastMinPromotionIcon,
        label: 'Ưu Đãi Phút Chót',
      };

    case PROMOTION_TYPE.BOOK_EARLY:
      return {
        icon: EarlyBookingPromotionIcon,
        label: 'Ưu Đãi Đặt Sớm',
      };

    case PROMOTION_TYPE.SAME_PROMOTION:
      return {
        icon: SameProMotionIcon,
        label: 'Ưu Đãi Điện Thoại',
      };

    case PROMOTION_TYPE.MEMBER_PROMOTION:
      return {
        icon: MemberPromotionIcon,
        label: 'Ưu đãi thành viên',
      };

    case PROMOTION_TYPE.RANK:
      return {
        icon: RankPromotionIcon,
        label: 'Ưu đãi Thứ Hạng',
      };

    case PROMOTION_TYPE.MARKETING:
      return {
        icon: MarketingPromotionIcon,
        label: 'Ưu đãi Tiếp Thị',
      };

    case PROMOTION_TYPE.TOURIST:
      return {
        icon: GuestPromotionIcon,
        label: 'Ưu Đãi Du khách',
      };

    case PROMOTION_TYPE.AGENCY:
      return {
        icon: AgencyPromotionIcon,
        label: 'Ưu Đãi Đại lý',
      };

    case PROMOTION_TYPE.ENTERPRISE:
      return {
        icon: EnterprisePromotionIcon,
        label: 'Ưu Đãi Đại Sứ',
      };

    default:
      return {};
  }
};

export default promotionRendering;
